import cn from 'classnames';
import { TableList } from 'seagull';
import { Typography } from 'seagull/components/Typography';
import { emptyCell } from "../../../constants";
import { invoiceModel } from "../../../models";
import { InvoiceLineItemsTableTestIds, qboIndicatorCell } from "./InvoiceLineItemsTable";
import styles from "./InvoiceSubLineItem.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function InvoiceSubLineItems(props) {
  const {
    subItem,
    quantity,
    disableMarginBottom,
    isVendor
  } = props;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableList.Row, {
      size: "small",
      disableMarginBottom: true,
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Name(0),
          className: styles.name,
          children: invoiceModel.subItemName(subItem)
        })
      }, qboIndicatorCell({
        isGrouped: false,
        qbo: subItem.qbo,
        isVendor,
        getRowTestId: () => InvoiceLineItemsTableTestIds.SubLineItem.QboIntegration(0)
      }), emptyCell, {
        value: /*#__PURE__*/_jsx(Typography, {
          skin: "disabled",
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Quantity(0),
          children: quantity
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          skin: "disabled",
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Rate(0),
          children: invoiceModel.subItemRate(subItem)
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          skin: "disabled",
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Discount(0),
          children: invoiceModel.subItemDiscount(subItem)
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          skin: "disabled",
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Total(0),
          children: invoiceModel.subItemTotalAmount(subItem)
        })
      }]
    }), /*#__PURE__*/_jsx(TableList.Row, {
      size: "fluid",
      className: styles.gapBottom,
      disableMarginBottom: disableMarginBottom,
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          className: cn(styles.name, disableMarginBottom && styles.gapBottom),
          "data-testid": InvoiceLineItemsTableTestIds.SubLineItem.Note(0),
          skin: "secondary",
          variant: "paragraph2",
          children: "hidden from your client"
        })
      }, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell]
    })]
  });
}